import { ExamUUIDObject } from '../tools/getFetchUUIDs';
import autoRefreshedExecuteGetFetchExamResultWithToken from './getFetchExamResult';
import { QUIZ_DATA } from '../../consts';

function extractUUIDs(examUUIDs: ExamUUIDObject[]): string[] {
    return examUUIDs.map(item => item.uuid);
};


const handleFetchRecent5ExamResult = async (
    allAvailableUUIDs: ExamUUIDObject[] | null,
    setOnsoScoreData: React.Dispatch<React.SetStateAction<{ [onso: string]: number }>>,
    accessToken: string | null
) => {
    try {
        const uuids = extractUUIDs(allAvailableUUIDs ?? []).slice(0, 5);
        console.log("Fetching recent 10 exam results for UUIDs:", uuids);
        if (!uuids || uuids.length === 0) {
            console.warn("No UUIDs available to fetch exam results.");
            return;
        }
        const response = await autoRefreshedExecuteGetFetchExamResultWithToken(accessToken, uuids);
        console.log("Fetched recent 10 exam results:", response.results);
        // Combine the results by merging arrays for each key
        const mergedResults: { [key: string]: boolean[] } = {};
        response.results.forEach(result => {
            if (result) {
                for (const key in result) {
                    if (!mergedResults[key]) {
                        mergedResults[key] = [];
                    }
                    mergedResults[key] = mergedResults[key].concat(result[key]);
                }
            }
        });
        // mergedResults now contains combined arrays for each key
        console.log("Merged results:", mergedResults);

        const scores: { [key: string]: number } = {};
        for (const key in mergedResults) {
            const values = mergedResults[key];
            // Calculate percentage (true count / total) * 100
            const trueCount = values.reduce((sum, val) => sum + (val ? 1 : 0), 0);
            const percentage = values.length > 0 ? (trueCount / values.length) * 100 : 0;
            scores[key] = percentage;
        }
        console.log("Scores as percentage (max 100):", scores);

        // Build a mapping from word to targetOnso for quick lookup
        const wordToOnso: { [word: string]: string } = {};
        Object.values(QUIZ_DATA).flat().forEach(q => {
            if (q.word && q.targetOnso) {
                wordToOnso[q.word] = q.targetOnso;
            }
        });

        // Prepare a mapping from targetOnso to an array of scores
        const onsoScores: { [onso: string]: number[] } = {};

        // Go through each subject (e.g., "hard-heard") and its score
        Object.entries(scores).forEach(([subject, score]) => {
            // Split subject by "-" to get individual words
            const words = subject.split('-');
            words.forEach(word => {
                const onso = wordToOnso[word];
                if (onso) {
                    if (!onsoScores[onso]) {
                        onsoScores[onso] = [];
                    }
                    onsoScores[onso].push(score);
                }
            });
        });

        // Calculate the average score for each targetOnso
        const targetOnsoDict: { [onso: string]: number } = {};
        Object.entries(onsoScores).forEach(([onso, arr]) => {
            const avg = arr.reduce((sum, val) => sum + val, 0) / arr.length;
            targetOnsoDict[onso] = parseFloat(avg.toFixed(2));
        });

        setOnsoScoreData(targetOnsoDict);
        // Now targetOnsoDict is ready to use
        console.log("Target Onso Dictionary with average scores:", targetOnsoDict);

    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

export default handleFetchRecent5ExamResult;
